const OrderStatusBadge = ({ status, statusKey, statusLabel }) => {
  const statusConfig = {
    pending: { label: 'Pending', class: 'badge-warning' },
    packed: { label: 'Packed', class: 'badge-info' },
    shipped: { label: 'Shipped', class: 'badge-primary' },
    completed: { label: 'Completed', class: 'badge-success' },
    canceled: { label: 'Canceled', class: 'badge-danger' },
    returned: { label: 'Returned', class: 'badge-neutral' },
  };

  const normalizedStatus = (statusKey ?? statusLabel ?? status ?? '').toString().toLowerCase();
  const fallbackLabel = statusLabel ?? status ?? '';
  const config = statusConfig[normalizedStatus] || { label: fallbackLabel, class: 'badge-neutral' };

  return <span className={`badge ${config.class}`}>{config.label}</span>;
};

export default OrderStatusBadge;
